// extracted by css-extract-rspack-plugin
export default {"root":"root-UUivdZ","svg__jeWc1":"svg__jeWc1-gF9FIC","svgJeWc1":"svg__jeWc1-gF9FIC","svg___5FElZ":"svg___5FElZ-nnMVDv","svg5FElZ":"svg___5FElZ-nnMVDv"};